export default {
  // 数据分析
  data_analysis: {
    viewdata: '查看数据',
    adapterDevice: '适配设备',
    exit: '退出',
    fullScreen: '全屏',
    preview: '预览',
    today: '今日',
    update: '更新',
    chartNoDate: '图表无数据',
    addChart: '添加图表',
    fenpeiShare: '分配共享',
    allFilter: '全局筛选',
    cilckCancelLinkage: '点击取消联动',
    allFilterSet: '全局筛选设置',
    screen: '筛选',
    chartLinkageSet: '图表联动设置',
    timeUpdateSet: '定时刷新设置',
    copyChart: '复制图表',
    editChart: '编辑图表',
    chartLinkage: '图表联动',
    timeUpdate: '定时刷新',
    personnel: '人员',
    minAddOneChart: '请至少添加一个图表',
    dataChangeIfSave: '数据发生改变，需要保存吗?',
    saveOkReturn: '保存成功，正在返回...',
    shareToMe: '分享给我的',
    addReport: '新增数据分析',
    noNameChart: '未命名图表',
    dataIsNormal: '数据正常',
    time: '时间',
    statistical: '统计',
    dimension: '维度',
    editShowName: '修改显示名称',
    dimensionColumn: '维度(列)',
    value: '数值',
    editFiledName: '修改字段名称',
    subtotal: '小计',
    total: '合计',
    sum: '求和',
    average: '平均值',
    min: '最小值',
    max: '最大值',
    count: '计数',
    repeatCount: '去重计数',
    dataFormat: '数据格式',
    useYear: '按年',
    useHalfYear: '按半年',
    useQuarter: '按季度',
    useMounth: '按月',
    useWeek: '按周',
    useDay: '按日',
    useDepartment: '按部门',
    usePersonnel: '按人',
    sort: '排序',
    default: '默认',
    asc: '升序',
    desc: '降序',
    alignment: '对齐方式',
    left: '左对齐',
    center: '居中',
    chartName: '图表名称',
    right: '右对齐',
    show: '显示',
    chartType: '图表类型',
    assistSet: '辅助设置',
    align: '对齐',
    remarkColor: '标记颜色',
    warningSet: '预警设置',
    numberOfEntries: '条目数',
    showTiaoshu: '显示条数',
    pageSet: '翻页设置',
    tableSet: '表格设置',
    chartSet: '图例设置',
    showSet: '显示设置',
    showTag: '显示标签',
    showValue: '显示数值',
    showPercent: '显示百分比',
    chartScreenSet: '图内筛选设置',
    range: '范围',
    targetValue: '目标值',
    addOption: '添加项',
    filterSet: '过滤条件设置',
    highCondition: '高级条件',
    addScreenCondition: '添加筛选条件',
    juLeft: '居左',
    juRight: '居右',
    top: '顶部',
    bottom: '底部',
    customerLevel: '客户等级',
    principal: '负责人',
    before: '前',
    after: '后',
    targetValueAfterMax: '目标值后面的值必须大于前面的值',
    max8Option: '最多只能添加8项',
    dataSource: '数据源',
    moveUnderFieldToValue: '可将下面字段拖入到维度/数值中',
    field: '字段',
    addField: '添加字段',
    sureDelField: '确定要删除该字段吗?',
    fieldNameMust: '字段名称必填',
    themeStyle: '主题样式',
    pureColor: '纯色',
    picture: '图片',
    custom: '自定义',
    chartColor: '图表配色',
    borderSet: '边框设置',
    color: '颜色',
    borderType: '线段类型',
    borderWidth: '线段宽度',
    white: '白',
    grey: '灰',
    blue: '蓝',
    yellow: '黄',
    black: '黑',
    purple: '紫',
    pleaseAddFormula: '请添加公式',
    pleaseAddFormula1: '公式内容不能为空',
    operator: '运算符',
    returnType: '返回类型',
    decimalDigits: '小数位数',
    precision: '精确度',
    dayu: '大于',
    xiaoyu: '小于',
    dengyu: '等于',
    budengu: '不等于',
    dayudengyu: '大于等于',
    xiaoyudengyu: '小于等于',
    weikong: '为空',
    buweikong: '不为空',
    number: '数字',
    integer: '整数',
    percent: '百分比',
    rounded: '四舍五入',
    quweifa: '去尾法',
    jinyifa: '进一法',
    noFengefu: '无分隔符',
    qianFengefu: '千分位分隔符',
    wanFengefu: '万分位分隔符',
    sameDataSource: '相同数据源，不需要设置联动字段',
    setMainLinkage: '请设置与主图表联动的字段',
    guanlianFieldNotEmpty: '关联字段不能为空',
    selectedField: '已选字段',
    addField1: '已添加字段',
    contion: '条件',
    screenContion: '筛选条件',
    showColor: '显示颜色',
    pleaseInputName: '请输入名称',
    refreshRate: '刷新频率',
    enter5Interger: '请输入大于5的整数',
    seconds: '秒',
    minute: '分',
    hour: '时',
    selectChartDataSource: '请选择图表数据源',
    qiehuanClear: '切换数据源将清空该图表所有设置',
    sureQiehuan: '确定要切换吗?',
    yes: '是',
    no: '否',
    highlight: '高亮显示',
    contionSetError: '条件设置有误',
    screenOption: '筛选项',
    selectScreenChart: '请选择需要筛选的图表',
    selectScreenField: '请选择作为筛选项的字段',
    zhishaoSelectOneChart: '请选择作为筛选项的字段',
    haveFilterEmpty: '存在为空的筛选项字段',
    nameNotRepeat: '名称不允许重复',
    enterDsign: '进入设计',
    multiChartCalculation: '多图表计算',
    chartNumber: '图表-数字图',
    leftAddFormula: '请从左侧数字图表中添加公式字段',
    showChartType: '显示图表类型',
    chartNameMustFill: '图表名称必填',
    tongbiHuanbi: '同比环比',
    tongbi: '同比',
    huanbi: '环比',
    huanbiUpValue: '环比增长值',
    huanbiUpLv: '环比增长率',
    lastWeekTBValue: '上周同比值',
    lastWeekTBLv: '上周同比率',
    lastMonthTBValue: '上月同比值',
    lastMonthTBLv: '上月同比率',
    lastYearTBValue: '上年同比值',
    lastYearTBLv: '上年同比率',
    showChartCount: '显示图内统计',
    analysisFormulaTip1: '函数中只能添加数字和日期组件',
    analysisFormulaTip2: '函数中只能添加数字组件',
    chooseRequiredAnd: '请选择需要与',
    linkageChart: '联动的图表',
    DimensionRequired: '维度必填',
    startTimeRequired: '开始时间必填',
    endTimeRequired: '结束时间必填',
    DimensionValueNotValue: '维度和数值不能同时为空',
    progress: '进度',
    listFields: '列表字段',
    dontDragExistingField: '不能拖入已存在的字段',
    dragTimeCompent: '请拖入时间组件',
    dragValeCompent: '请拖入数字组件',
    GanttMaxDimension: '甘特图的维度字段不能大于三个',
    Timescale: '时间刻度',
    chartDisplaySetting: '图形显示字段设置',
    quarter: '季度',
    FirstQuarter: '一季度',
    SecondQuarter: '二季度',
    ThirdQuarter: '三季度',
    FourthQuarter: '四季度',
    January: '1月',
    February: '2月',
    March: '3月',
    April: '4月',
    May: '5月',
    June: '6月',
    July: '7月',
    August: '8月',
    September: '9月',
    October: '10月',
    November: '11月',
    December: '12月',
    theTimeScale: '时间刻度',

    // 2021-03-15
    ganttTimeTips: '开始时间必须小于或等于结束时间，否则图表显示为空',

    // 2024-05-20
    chartScreen: '图内筛选',
    linkage: '联动',
    viewSourceData: '查看原始数据',
    addKanban: '添加看板',
    group: '分组',
    searchReportDesc: '搜索报表、报表描述',
    dataUpdataBy: '数据更新至',
    kanbanName: '看板名称',
    fromGroup: '所属分组',
    tips: '温馨提示',
    addGroup_tips1: '上下拖动分组进行排序，可点击编辑名称',
    addGroup_tips2: '有看板的分组不可删除',
    groupKanban: '分组内看板',
    sourDelGroup: '确定要删除该分组吗？',
    kanbanNameMust: '看板名称必填',
    groupNameMust: '所属分组必填',
    layoutContainer: '布局容器',
    appearanceSetting: '外观设置',
    ApplyTemplate: '套用模板',
    width: '宽',
    height: '高',
    column: '列',
    cell: '格',
    editKanban: '编辑看板',
    growthValue: '增长值',
    growthRate: '增长率',
    contraRatio: '对比值',
    nonameLayout: '未命名布局容器',
    noSelectSource: '未选择数据源',
    chartStyle: '图表样式',
    dashboardStyle: '仪表盘样式',
    styleSetTips1: '请选择左侧图表进行设置',
    styleSetTips2: '按住Ctrl/Command+鼠标点选”可批量选择图表设置',
    showTitle: '显示标题',
    layoutName: '布局名称',
    layoutStyle: '布局样式',
    backgroundOpacity: '背景透明度',
    titleAlign: '标题对齐',
    chartInnerFont: '图内字体',
    showBorder: '显示边框',
    allDefaultColor: '默认整体配色',
    thisBatchSet: '此设置为批量修改设置，点击后不可以恢复',
    dashboardAllset: '仪表盘整体',
    allBackground: '整体背景',
    allChartsStyle: '图表样式',
    titleBckground: '标题背景',
    colorPlan: '配色方案',
    gradation: '渐变',
    tableTypeCharts: '表格类图表',
    chartMainColor: '图表主色',
    titleFontColor: '表头文字',
    contentText: '内容文字',
    point: '点',
    colorSetOptions1: '默认配色',
    colorSetOptions2: '经典配色',
    colorSetOptions3: '优雅格调',
    colorSetOptions4: '党政/教务',
    colorSetOptions5: '温馨暖调',
    colorSetOptions6: '潮流绿紫',
    colorSetOptions7: '智慧商务',
    colorSetOptions8: '智慧金融',
    colorSetOptions9: '科技商务',
    colorSetOptions10: '天空',
    colorSetOptions11: '热情',
    colorSetOptions12: '清新',
    colorSetOptions13: '日光',
    colorSetOptions14: '神秘',
    colorSetOptions15: '柠檬',
    colorSetOptions16: '极光',
    functionConfig: '功能配置',
    dateField: '日期字段',
    valueSet: '数值设置',
    selectDate: '所选日期',
    sourceData: '原始数据',
    layoutSelect: '布局选择',
    valueCardSize: '数值卡尺寸',
    miniCard: '小指标卡',
    maxCard: '大指标卡',
    iconLocation: '图标位置',
    iconColor: '图标颜色',
    sideStrip: '侧边条',
    mapColor: '地图颜色',
    valueAlign: '数值对齐',
    themeColor: '主题颜色',
    lastWeekTb: '上周同比',
    lastMonthTb: '上月同比',
    lastYearTb: '去年同比'
  }
}
